import { http } from "@/services/http";

export const flattenObject = (ob) => {
  let toReturn = {};

  for (let i in ob) {
      if (!ob.hasOwnProperty(i)) continue;

      if ((typeof ob[i]) == 'object' && !Array.isArray(ob[i]) && ob[i] !== null) {
          let flatObject = flattenObject(ob[i]);
          for (let x in flatObject) {
              if (!flatObject.hasOwnProperty(x)) continue;
              if(ob.hasOwnProperty(x)) {
                  toReturn[i + '.' + x] = flatObject[x];
              } else {
                  toReturn[x] = flatObject[x];
              }
          }
      } else {
          toReturn[i] = ob[i];
      }
  }
  return toReturn;
};

export function isFalsy(value) {
  return value === "" || value === null || value === false || value === "false";
}


/**
 * Takes a filter object to pass to the server, and adds common filters based on
 * the selected alternative and type.
 */
export function addGenericFilters(alternative, filter_obj)
{
    if (alternative == "conventional")
    {
        filter_obj["none"] = [ 
            {"brand": ["Philips"]},
            { "any": [
                {"driver_type": "LED"}, 
                {"lamp_type": "LED"},
                {"dr_type": "LED"}
            ]}
        ];
    }
    else
    {
        filter_obj["none"] = [
            { "any": [
                {"driver_type": "LED"}, 
                {"lamp_type": "LED"},
                {"dr_type": "LED"}
            ]}
        ];
    }
    return filter_obj;
}



/**
 * Returns the thumbnail image associated with the product, or a context
 * appropriate placeholder depending on its type. Product is a dictionary with
 * all the product data.
 */
export function getImageURL(product)
{
    if ("image_url" in product) 
        return product["image_url"];
    if (product["type"] == "driver")
        return "placeholders/icon_2.svg";
    if (product["lamp_type"] == "LED")
        return "placeholders/icon_3.svg";
    return "placeholders/icon_1.svg";
}

/**
 * Returns true if the product has an image, or false if the image used will be
 * a placeholder.
 */
export function hasImage(product) {
    return "image_url" in product;
}


export function getMatches(vendor, country, type, pk, lamp_driver_type) {
    return http.get(`/${type}s/${vendor}/${country}/${pk}/matches/${lamp_driver_type}/`)
        .then(response => {
            return response.data
        })
        .catch(err => {
            console.log(err);
        });
}


export function isLamp(product_data) {
    return product_data.hasOwnProperty("lamp_type");
}


export function isLed(product_data) {
    if (isLamp(product_data))
        return product_data.lamp_type == "LED";
    return product_data.dr_type == "Driver";
}


// Returns a new array with fields which are only existent in both arr1 and arr2
export function arrAnd(arr1, arr2) {
    return arr1.filter(e => {
        return arr2.includes(e);
    });
}

export function addUnits(unitDictionary, facet, value) {
    let value_str = value;
    if (facet in unitDictionary) {
        let units = unitDictionary[facet];
        if (!value_str.endsWith(units))
            value_str += units;
    }
    return value_str;
}

export function colorCri(value) {
    switch (Number(value)) {
        case 2700: return "(827/927)";
        case 3000: return "(830/930)";
        case 3500: return "(835/935)";
        case 4000: return "(840/940)";
        case 5000: return "(850/950)";
        case 5400: return "(854/954)";
        case 6500: return "(865/965)";
        default: return null;
    }
}

export function valueNumber(facet, value) {
    switch (facet) {
        case "color": return Number(value);
        case "length": return Number(value);
        case "discrete_wattage": return Number(value.substr(0, value.length - 1));
        case "lumen": return Number(value.substr(0, value.length - 2));
        default: return null;
    }
}
